import React, { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import classnames from "classnames";

import useWindowResize from "../../../../hooks/useWIndowResize";
import ROUTES from "../../../../constants/routes";
import useWindowScroll from "../../../../hooks/useWindowScroll";
import { elementIsInViewPort } from "../../../../libs/helpers/dom";
import useQuotePopup from "../../../../hooks/useQuotePopup";
import { Layout, Flex } from "../../../../components/Layout";
import BackButton from "../BackButton/BackButton";
import { getPathWithPartner } from "../../../../libs/helpers/location";
import "./styles.css";
import Datalayer from "../../../../libs/vendors/data-layer";
import { CLICK_DESCRIPTION } from "../../../../constants/datalayer";
import logoPacifico from '../../../../assets/images/header/logo-pacifico.png';

const Header = () => {
    const { openQuotePopup } = useQuotePopup();
    const { scrollPosition } = useWindowScroll(0);
    const { isMobile } = useWindowResize();
    const location = useLocation();
    const { partner, partnerType } = useSelector(state => ({
        ...state.HomeInsurance,
    }));
    const isHeaderFixedShow = elementIsInViewPort("#quote-here", scrollPosition, 0);
    const isLanding = useMemo(() => {
        return String(location.pathname).includes(
            getPathWithPartner(ROUTES.HOME_INSURANCE.LANDING, partner, partnerType)
        );
    }, [location.pathname, partner, partnerType]);
    const isConfirm = useMemo(() => {
        return String(location.pathname).includes(
            getPathWithPartner(ROUTES.HOME_INSURANCE.CONFIRM1, partner, partnerType)
        );
    }, [location.pathname, partner, partnerType]);

    const onOpenQuoteModal = useCallback(() => {
        Datalayer.sendClickAction(
            "Inicio",
            `Botón banner: ${CLICK_DESCRIPTION.BTN_QUOTATION}`
        );
        openQuotePopup();
    }, [openQuotePopup]);

    return (
        <>
            {isLanding && (
                <header
                    className={classnames(
                        "header header--landing header--landing--fixed",
                        {
                            "header--landing--fixed--show": isHeaderFixedShow,
                        }
                    )}
                >
                    <div className="header__content">
                        <img
                            title="logo pacifico"
                            src={logoPacifico}
                            id="logo-pacifico"
                            alt="logo pacifico"
                            height={isMobile ? 25 : 31}
                        />
                    </div>
                    <button
                        aria-label="Asesoría Personalizada"
                        className="header__quote"
                        id="quote-here-header"
                        onClick={onOpenQuoteModal}
                        type="button"
                    >
                        Asesoría Personalizada
                    </button>
                </header>
            )}
            <header className={classnames("header", { "header--landing": isLanding })}>
                <div className="header__content">
                    <Layout direction="row">
                        <Flex className="header__button-left" id="goLeft">
                            {!isLanding && !isConfirm && (
                                <BackButton isMobile={isMobile} />
                            )}
                        </Flex>
                    </Layout>
                    <Layout style={{ width: "100%" }}>
                        <Flex flex="0 0 100%">
                            <Layout direction="row" style={{ justifyContent: "center" }}>
                                <img
                                    title="logo pacifico"
                                    src={logoPacifico}
                                    id="logo-pacifico-fixed"
                                    alt="logo pacifico fijo"
                                    height={isMobile ? 25 : 31}
                                />
                            </Layout>
                        </Flex>
                    </Layout>
                </div>
            </header>
        </>
    );
};

export default React.memo(Header);
